import { isVNode as _isVNode, createVNode as _createVNode2, createTextVNode as _createTextVNode2 } from "vue";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-d75c4780"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定");

import { NForm, NFormItem, NInput, NSpace, NButton, NEllipsis, useMessage, NAlert, NImage } from 'naive-ui';
import { reactive, ref, toRefs, onMounted, computed } from 'vue';
import { getNavInfo as getNavInfoApi, getIconAndTitle as getIconAndTitleApi } from '@teams/common/api';
import { useGroupStore } from '../../store/group';
import { useNavigatorStore } from '../../store/navigator';
import defaultAppIcon from '../../assets/defaultAppIcon.svg';
import handleResponseError from '@teams/common/hooks/useResponseError';

function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateNewAppDialog',
  props: {
    appId: null
  },
  emits: ["closeDialog"],

  setup(__props, {
    emit: emits
  }) {
    const props = __props; // 新建or修改网页链接信息

    const message = useMessage();
    const navigatorStore = useNavigatorStore();
    const {
      appId
    } = toRefs(props);
    const defaultForm = {
      appName: '',
      appIcon: '',
      appIconToken: '',
      appLink: ''
    };
    const showIcon = ref(false);
    const form = reactive({ ...defaultForm
    });
    let originalAppInfo = reactive({ ...defaultForm
    });
    const fromRef = ref(null);
    const checkContent = computed(() => {
      if (checkUrl(form.appLink) && form.appName !== '') {
        return false;
      } else {
        return true;
      }
    });
    const nameMaxLength = 256;
    const rules = {
      appLink: [{
        required: true,
        validator: (_rule, value) => {
          return new Promise((resolve, reject) => {
            if (value === '') {
              resolve();
            } else if (!checkUrl(value)) {
              reject(Error('输入的链接有误'));
            } else {
              resolve();
            }
          });
        },
        trigger: ['blur']
      }, {
        required: true,
        validator: () => {
          return true;
        },
        trigger: ['focus']
      }],
      appName: [{
        required: true,

        validator(_rule, value) {
          return new Promise((resolve, reject) => {
            if (value.length >= nameMaxLength) {
              reject(Error(`名称不得超过${nameMaxLength}个字符`));
            } else {
              resolve();
            }
          });
        },

        trigger: ['input', 'blur']
      }]
    };

    const close = () => {
      emits('closeDialog');
    };

    const groupStore = useGroupStore();

    const getAppIconAndTitle = async () => {
      const url = form.appLink;

      if (url === '') {
        form.appIcon = defaultAppIcon;
        return;
      }

      try {
        const groupId = groupStore.groupId;
        const {
          data
        } = await getIconAndTitleApi(groupId, url);
        form.appIcon = data.icon || defaultAppIcon;

        if (form.appName === '') {
          form.appName = data.title.slice(0, 200);
        }

        form.appIconToken = data.icon_token;
        showIcon.value = true;
      } catch (error) {}
    };

    const addAppButtonLoading = ref(false);

    const submit = async () => {
      addAppButtonLoading.value = true; // 默认根据url获取一个最新的icon

      const groupId = groupStore.groupId;
      const {
        data
      } = await getIconAndTitleApi(groupId, form.appLink);
      form.appIcon = data.icon || defaultAppIcon;

      if (form.appName === '') {
        form.appName = data.title.slice(0, 200);
      }

      form.appIconToken = data.icon_token;

      try {
        if (appId.value !== 0) {
          // 修改：判断哪些参数呗修改了
          const data = { ...checkFormChange(form)
          };
          await navigatorStore.updateAppLink(appId.value, data);
        } else {
          // 新增
          const params = {
            auto_update: false,
            parent_id: 0,
            name: form.appName,
            icon: form.appIconToken,
            kind: 'appCustom',
            kvs: [{
              key: 'url',
              value: `{{url "${form.appLink}"}}`
            }] // role_perms, 不传该参数，服务端默认空间内成员有权限

          };
          await navigatorStore.addAppLink(params);
          message.success('添加成功');
        }

        close();
      } catch (error) {
        // 40021007 ：url重复的错误代码
        if (error.response?.data.code === 40021007) {
          const icon = form.appIcon || error.response?.data.debug.icon;
          const name = error.response?.data.debug.name;
          message.error('当前已存在相同的网页链接', {
            render: () => {
              return renderMessage(icon, name);
            },
            showIcon: false
          });
        } else {
          handleResponseError(error);
        }
      }

      addAppButtonLoading.value = false;
    };

    const renderMessage = (icon, name) => {
      return _createVNode2(NAlert, {
        "type": "error",
        "show-icon": false,
        "class": "messageBoxNAlert"
      }, {
        default: () => [_createVNode2("div", {
          "class": "messageBoxInRenderMessage"
        }, [_createVNode2("span", {
          "class": "alertText"
        }, [_createTextVNode2("\u5F53\u524D\u5DF2\u5B58\u5728\u76F8\u540C\u7684\u7F51\u9875\u94FE\u63A5\uFF1A")]), _createVNode2(NImage, {
          "width": "16",
          "height": "16",
          "src": icon || defaultAppIcon,
          "class": "appIcon",
          "preview-disabled": true
        }, null), _createVNode2(NEllipsis, {
          "style": "max-width: 150px",
          "class": "name"
        }, _isSlot(name) ? name : {
          default: () => [name]
        })])]
      });
    };

    const checkUrl = url => {
      const reg = /^(?:(http|https|ftp):\/\/)?[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|?]/i;
      return reg.test(url);
    };

    const checkFormChange = formValue => {
      const params = reactive({});

      if (formValue.appIcon !== originalAppInfo.appIcon) {
        params.icon = form.appIconToken;
      }

      if (formValue.appName !== originalAppInfo.appName) {
        params.name = form.appName;
      }

      if (formValue.appLink !== originalAppInfo.appLink) {
        params.kvs = [{
          key: 'url',
          value: `{{url "${form.appLink}"}}`
        }];
      }

      return params;
    }; //  初始化app详情


    const initAppInfo = async id => {
      const {
        data
      } = await getNavInfoApi(groupStore.groupId, id);
      form.appName = data.name;
      form.appIcon = data.icon || defaultAppIcon;
      form.appLink = data.kvs.find(item => item.key === 'url')?.value || '';
      originalAppInfo = { ...form
      };
      showIcon.value = true;
    };

    onMounted(() => {
      if (appId.value !== 0) {
        initAppInfo(appId.value);
      }
    });
    return (_ctx, _cache) => {
      const _component_n_from_item = _resolveComponent("n-from-item");

      return _openBlock(), _createBlock(_unref(NForm), {
        ref_key: "fromRef",
        ref: fromRef,
        model: form,
        "label-placement": "top",
        "label-width": "auto",
        "require-mark-placement": "right-hanging",
        rules: rules,
        "show-require-mark": false,
        class: "formBox"
      }, {
        default: _withCtx(() => [_createVNode(_unref(NFormItem), {
          path: "appLink",
          label: "网页链接"
        }, {
          default: _withCtx(() => [_createVNode(_unref(NInput), {
            value: form.appLink,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => form.appLink = $event),
            class: "formInput",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
            placeholder: "",
            onBlur: _cache[2] || (_cache[2] = () => getAppIconAndTitle()),
            clearable: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_unref(NFormItem), {
          path: "appName",
          label: "名称"
        }, {
          default: _withCtx(() => [_createVNode(_unref(NInput), {
            value: form.appName,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => form.appName = $event),
            class: "formInput",
            onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
            placeholder: "",
            clearable: "",
            maxlength: nameMaxLength
          }, {
            prefix: _withCtx(() => [_withDirectives(_createVNode(_unref(NImage), {
              width: "16",
              height: "16",
              src: form.appIcon,
              "preview-disabled": ""
            }, null, 8, ["src"]), [[_vShow, showIcon.value]])]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_n_from_item, {
          class: "formBox__item"
        }, {
          default: _withCtx(() => [_createVNode(_unref(NSpace), {
            justify: "end"
          }, {
            default: _withCtx(() => [_createVNode(_unref(NButton), {
              class: "config-form__btn cancelBtn",
              onClick: close
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            }), _createVNode(_unref(NButton), {
              type: "primary",
              class: "config-form__btn",
              onClick: submit,
              disabled: _unref(checkContent),
              loading: addAppButtonLoading.value
            }, {
              default: _withCtx(() => [_hoisted_2]),
              _: 1
            }, 8, ["disabled", "loading"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]);
    };
  }

});